import type { ScanRead } from '@worki/shared';

/**
 * SCAN-007 — what the server read off the pages, out of its header.
 *
 * Base64 because the header carries Hebrew and a header is Latin-1 by the
 * specification. `atob` gives back one byte per character rather than text, so
 * the bytes are decoded as UTF-8 by hand: read as characters, a supplier named
 * `בזק` arrives as six mojibake ones.
 *
 * Anything unexpected reads as nothing read: a scan whose header this cannot
 * parse is still a scan, and the form it feeds is one a person is about to fill
 * in themselves anyway.
 */
export function readFields(header: string | null): ScanRead | null {
  if (!header) return null;
  try {
    return JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(header), (c) => c.charCodeAt(0)))) as ScanRead;
  } catch {
    return null;
  }
}
